<mat-sidenav-container [dir]="direction" class="sidenav-container">

  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

    <mat-toolbar>{{'menu' | translate}}</mat-toolbar>

    <mat-nav-list *ngIf="role != 'Admin'">
      <!-- <mat-list-item routerLink="./"><mat-icon>dashboard</mat-icon>&nbsp; {{'dashboard' | translate}}</mat-list-item> -->

      <mat-expansion-panel [class.mat-elevation-z0]="true" dense *ngFor="let item of menuPerm">
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{item.menuName | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense *ngFor="let menuitem of item.lstmenuItem">

          <a mat-list-item [routerLink]="menuitem.link">
            <mat-icon>{{menuitem.icon}}</mat-icon>{{menuitem.name | translate}}
          </a>

        </mat-nav-list>
      </mat-expansion-panel>

      <mat-list-item (click)="logout()">
        <mat-icon>logout</mat-icon>&nbsp; {{'logout' | translate}}
      </mat-list-item>
    </mat-nav-list>

    <mat-nav-list *ngIf="role == 'Admin'">
      <mat-list-item routerLink="./">
        <mat-icon>dashboard</mat-icon>&nbsp; {{'dashboard' | translate}}
      </mat-list-item>

      <mat-expansion-panel [class.mat-elevation-z0]="true" dense>
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{'cards' | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense>
          <a mat-list-item routerLink="./cards/categories">
            <mat-icon>category</mat-icon> {{'categories' | translate}}
          </a>
          <a mat-list-item routerLink="./cards/subcategory">
            <mat-icon>subdirectory_arrow_right</mat-icon>{{'subCategories' | translate}}
          </a>
          <a mat-list-item routerLink="./cards/products">
            <mat-icon>production_quantity_limits</mat-icon> {{'products' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./cards/advertize">
            <mat-icon>Announcement</mat-icon> {{'Advertize' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./cards/productcards">
            <mat-icon>credit_card</mat-icon> {{'productCardsManagment' | translate}}
          </a>
        </mat-nav-list>
      </mat-expansion-panel>



      <mat-expansion-panel [class.mat-elevation-z0]="true" dense *ngIf="role == 'Admin'">
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{'EFawateercome' | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense>

          <a mat-list-item routerLink="./efawateercome/efcategoriesList">
            <mat-icon>supervisor_account</mat-icon> {{ 'categories' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercome/efbillerslist">
            <mat-icon>supervisor_account</mat-icon> {{ 'billers' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercome/efbillersservicetypelist">
            <mat-icon>supervisor_account</mat-icon> {{ 'services' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercome/effeescategory">
            <mat-icon>supervisor_account</mat-icon> {{ 'efCategoryFees' | translate}}
          </a>


        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel [class.mat-elevation-z0]="true" dense *ngIf="role == 'Admin'">
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{'efReports' | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense>

          <a mat-list-item routerLink="./efawateercomereports/efordersbyid">
            <mat-icon>supervisor_account</mat-icon> {{ 'efOrderById' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercomereports/efordersbyuser">
            <mat-icon>supervisor_account</mat-icon> {{ 'efOrderByUser' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercomereports/efordersbycategory">
            <mat-icon>supervisor_account</mat-icon> {{ 'efOrderBycategory' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercomereports/efordersbybiller">
            <mat-icon>supervisor_account</mat-icon> {{ 'efOrderBybiller' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercomereports/efordersbyservicetype">
            <mat-icon>supervisor_account</mat-icon> {{ 'efOrderByService' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercomereports/efpostpaidorders">
            <mat-icon>supervisor_account</mat-icon> {{ 'efPostpaidOrder' | translate}}
          </a>

          <a mat-list-item routerLink="./efawateercomereports/efprepaidorders">
            <mat-icon>supervisor_account</mat-icon> {{ 'efPrepaidOrder' | translate}}
          </a>



        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel [class.mat-elevation-z0]="true" dense>
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{'options' | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense>
          <a mat-list-item routerLink="./options/customers">
            <mat-icon>supervisor_account</mat-icon> {{ 'customers' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/adduser">
            <mat-icon>supervisor_account</mat-icon>{{'addUser' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/addcustomer">
            <mat-icon>smartphone</mat-icon>{{'addUserMobile' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/mandoobsList">
            <mat-icon>supervisor_account</mat-icon>{{'MandoobsMenu' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/updateuserbalance">
            <mat-icon>attach_money</mat-icon>{{'usersBalance' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/updatemandoobbalance">
            <mat-icon>attach_money</mat-icon>{{'mandoobsBalance' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item (click)="onClickMessages()" routerLink="./options/messages">
            <mat-icon>message</mat-icon>
            <p>
              <span [matBadge]="notSeenMessageCount" [matBadgeHidden]="notSeenMessageCount == 0" matBadgeColor="warn"
                matBadgeOverlap="false">{{'messages' | translate}}</span>
            </p>
          </a>

          <a *ngIf="role == 'Admin'" mat-list-item (click)="onClickDirectCharge()" routerLink="./options/directcharge">
            <mat-icon>message</mat-icon>
            <p>
              <span [matBadge]="notSeenDirectChargeCount" [matBadgeHidden]="notSeenDirectChargeCount == 0"
                matBadgeColor="warn" matBadgeOverlap="false">{{'directChargeOrders' | translate}}</span>
            </p>
          </a>

          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/systemdata">
            <mat-icon>article</mat-icon>{{'systemData' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/notification">
            <mat-icon>notifications</mat-icon>{{'notifications' | translate}}
          </a>
          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/alert">
            <mat-icon>notifications</mat-icon>{{'alert' | translate}}
          </a>
          <!-- <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/sendSMS">
            <mat-icon>textsms</mat-icon>{{'sendSMS' | translate}}
          </a> -->

          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./cards/paymentproviders">
            <mat-icon>attach_money</mat-icon>{{'paymentProviders' | translate}}
          </a>

          <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/otherInfoList">
            <mat-icon>info</mat-icon>{{'otherInfo' | translate}}
          </a>


        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel [class.mat-elevation-z0]="true" dense>
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{'reports' | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense>
          <a mat-list-item routerLink="./reports/orderbyid">
            <mat-icon>article</mat-icon>{{'orderById' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/allByDate">
            <mat-icon>article</mat-icon>{{'cardsOrders' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/mandoobStatment">
            <mat-icon>article</mat-icon>{{'mandoobStatment' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/ordersbycategorystatment">
            <mat-icon>article</mat-icon>{{'orderByCategoryStatment' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/ordersbysubcategorystatment">
            <mat-icon>article</mat-icon>{{'orderBySubCategoryStatment' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/ordersbyproductstatment">
            <mat-icon>article</mat-icon>{{'orderByProductStatment' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/ordersbydirectcharged">
            <mat-icon>article</mat-icon>{{'directChargedStatment' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/ordersbyuser">
            <mat-icon>article</mat-icon>{{'statmentByUser' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/usertrans">
            <mat-icon>article</mat-icon>{{'userTrans' | translate}}
          </a>
          <a mat-list-item routerLink="./reports/usertransdeposits">
            <mat-icon>article</mat-icon>{{'userTransdeposit' | translate}}
          </a>

          <a mat-list-item routerLink="./reports/usertransall">
            <mat-icon>article</mat-icon>{{'userOrdersReport' | translate}}
          </a>


          <a mat-list-item routerLink="./reports/profits">
            <mat-icon>article</mat-icon>{{'calculateProfits' | translate}}
          </a>

          <a mat-list-item routerLink="./reports/productcardsreport">
            <mat-icon>article</mat-icon>{{'productCardsReport' | translate}}
          </a>

          <a mat-list-item routerLink="./reports/pyticorderscard">
            <mat-icon>article</mat-icon>{{'pyticOrderCards' | translate}}
          </a>

          <a mat-list-item routerLink="./reports/mandoobtrans">
            <mat-icon>article</mat-icon>{{'mandoobTrans' | translate}}
          </a>

          <a mat-list-item routerLink="./reports/userbymandoobtrans">
            <mat-icon>article</mat-icon>{{'userBymandoobTrans' | translate}}
          </a>

        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel [class.mat-elevation-z0]="true" dense>
        <mat-expansion-panel-header>
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          &nbsp;
          {{'systemSettings' | translate}}
        </mat-expansion-panel-header>
        <mat-nav-list dense>

          <!-- <a mat-list-item routerLink="./systemsettings/menus">
            <mat-icon>article</mat-icon>Menu
          </a>
          <a mat-list-item routerLink="./systemsettings/menuitems">
            <mat-icon>article</mat-icon>Menu items
          </a> -->

          <a mat-list-item routerLink="./systemsettings/permissions">
            <mat-icon>article</mat-icon>{{'permissions' | translate}}
          </a>
          <a mat-list-item routerLink="./systemsettings/appColor">
            <mat-icon>article</mat-icon>{{'settings' | translate}}
          </a>

          <a mat-list-item routerLink="./systemsettings/qrcategory">
            <mat-icon>article</mat-icon>{{'qrCategories' | translate}}
          </a>

          <a mat-list-item routerLink="./systemsettings/categorypermission">
            <mat-icon>article</mat-icon>{{'categoryPermission' | translate}}
          </a>

          <a mat-list-item routerLink="./systemsettings/assistancedirectchargepermission">
            <mat-icon>article</mat-icon>{{'assistanceDirectCharge' | translate}}
          </a>



        </mat-nav-list>
      </mat-expansion-panel>


      <mat-list-item (click)="logout()">
        <mat-icon>logout</mat-icon>&nbsp; {{'logout' | translate}}
      </mat-list-item>

    </mat-nav-list>

  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <!-- *ngIf="isHandset$ | async" -->
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>{{'cardsrecharged' | translate}}</span>
      <span class="spacer"></span>
      <!-- <a mat-list-item href="#">User</a> -->

      <button mat-button [matMenuTriggerFor]="menu">{{userFullName}}</button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item routerLink="./options/changePassword">{{'changePassword' | translate}}</button>
        <button mat-menu-item (click)="logout()">{{'logout' | translate}}</button>
      </mat-menu>

    </mat-toolbar>
    <!-- Add Content Here -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>